import {LevelDescription} from "./level-description";

export class Level {
    public id: number;
    public name: string;
    public email: string;
    public level: number;
    public parent?: number;
    public description: LevelDescription = new LevelDescription();
    public active: boolean;
    public lang: string;

    constructor() {

    }

    public setLevel(data: any) {

        this.name = data.name;
        this.email = data.email;
        this.lang = data.lang;
        this.level = data.level;
        this.active = data.active;
        this.parent = data.parent ? data.parent.id : null;
        this.description.street = data.description.street;
        this.description.supplement = data.description.supplement;
        this.description.city = data.description.city;
        this.description.zipcode = data.description.zipcode;
        this.description.country = data.description.country;
        this.description.notes = data.description.notes ? data.description.notes : null;

    }
}
